import Formsy from "formsy-react";
import React, { SyntheticEvent } from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  children: JSX.Element[] | JSX.Element;
  onValidSubmit(event: SyntheticEvent<HTMLFormElement>): Promise<void> | void;
  onValid(): void;
  onInvalid(): void;
  getErrorMessage?(): string;
  getValue?(): string;
  hasValue?(): boolean;
  isFormDisabled?(): boolean;
  isFormSubmitted?(): boolean;
  isPristine?(): boolean;
  isRequired?(): boolean;
  isValid?(): boolean;
  isValidValue?(): boolean;
  resetValue?(): void;
  setValidations?(validations: any, required: boolean): void;
  setValue?(value: string): void;
  showError?(): boolean;
  showRequired?(): boolean;
}
const Form = styled((props: IProps) => (
  <Formsy {...props}>{props.children}</Formsy>
))`
  background: ${theme.color.white};
  padding: 3rem 4rem 2rem 4rem;
  border-radius: ${theme.global.radius};
`;

export default Form;



// WEBPACK FOOTER //
// ./src/components/common/Form/Form.tsx